import React, { useState } from "react";
import { api } from "../lib/api";
import { VideoCard } from "../components/VideoCard";
import { useInfiniteList } from "../lib/useInfiniteList";
import { Loader2 } from "lucide-react";

const PAGE = 4;

export default function Debates() {
  const [sort, setSort] = useState("recent");
  const { items, loading, loadingMore, hasMore, sentinelRef } = useInfiniteList(
    (skip, limit) => api.get(`/debates?sort=${sort}&limit=${limit}&skip=${skip}`).then((r) => r.data),
    [sort],
    PAGE
  );

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-6 lg:py-10">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8 border-b border-border pb-6">
        <div>
          <div className="label-mono text-muted-foreground mb-1">All debates</div>
          <h1 className="font-serif text-4xl">The arena</h1>
        </div>
        <div className="border border-border">
          {["recent", "trending"].map((s) => (
            <button
              key={s}
              onClick={() => setSort(s)}
              data-testid={`debates-sort-${s}`}
              className={`label-mono px-5 py-2.5 transition-colors ${
                sort === s ? "bg-foreground text-background" : "text-muted-foreground hover:bg-secondary"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="label-mono text-muted-foreground flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-border p-16 text-center">
          <div className="label-mono text-muted-foreground">No debates yet — start the first argument</div>
        </div>
      ) : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 fade-in stagger" data-testid="debates-grid">
            {items.map((d) => (
              <VideoCard key={d.id} item={d} type="debate" />
            ))}
          </div>

          {/* Sentinel + more-indicator */}
          <div ref={sentinelRef} className="h-1 mt-6" data-testid="debates-sentinel" />
          {loadingMore && (
            <div className="flex items-center justify-center py-6 label-mono text-muted-foreground gap-2" data-testid="debates-loading-more">
              <Loader2 className="w-4 h-4 animate-spin" /> Loading more…
            </div>
          )}
          {!hasMore && items.length > PAGE && (
            <div className="text-center label-mono text-muted-foreground py-6" data-testid="debates-end">
              You&apos;ve reached the end · {items.length} debates
            </div>
          )}
        </>
      )}
    </div>
  );
}
